import { intersection } from 'lodash';

import { INSTRUCTOR_CATEGORIES } from '@classCreation/data/instructorCategories';
import { SBAT_GROUP_FILTERS } from '@classCreation/data/sbatGroupFilters';
import getSbatGroupInstructorsByCategory from '@classCreation/utils/getSbatGroupInstructorsByCategory';

export default function applyFiltersOnSbatGroup({ sbatGroup, filters }) {
  const results = [];

  if (filters[SBAT_GROUP_FILTERS.academyTopics]) {
    const filterAcademyTopicIds = filters[SBAT_GROUP_FILTERS.academyTopics].map(
      ({ value }) => value
    );
    results.push(filterAcademyTopicIds.includes(sbatGroup.academy_topic_id));
  }

  if (filters[SBAT_GROUP_FILTERS.academyModules]) {
    const filterAcademyModuleIds = filters[
      SBAT_GROUP_FILTERS.academyModules
    ].map(({ value }) => value);
    results.push(
      filterAcademyModuleIds.includes(sbatGroup.academy_topic.academy_module.id)
    );
  }

  if (filters[SBAT_GROUP_FILTERS.superBatches]) {
    const filterSuperBatchIds = filters[SBAT_GROUP_FILTERS.superBatches].map(
      ({ value }) => value
    );
    const sbatGroupSuperBatchIds = sbatGroup.super_batch_academy_topics.map(
      ({ super_batch }) => super_batch.id
    );
    results.push(
      intersection(filterSuperBatchIds, sbatGroupSuperBatchIds).length > 0
    );
  }

  if (filters[SBAT_GROUP_FILTERS.primaryInstructors]) {
    const filterInstructorsIds = filters[
      SBAT_GROUP_FILTERS.primaryInstructors
    ].map(({ value }) => value);
    const sbatGroupInstructorsIds = getSbatGroupInstructorsByCategory(
      sbatGroup,
      INSTRUCTOR_CATEGORIES.primary
    ).map(({ instructor_id }) => instructor_id);

    results.push(
      intersection(filterInstructorsIds, sbatGroupInstructorsIds).length > 0
    );
  }

  if (filters[SBAT_GROUP_FILTERS.secondaryInstructors]) {
    const filterInstructorsIds = filters[
      SBAT_GROUP_FILTERS.secondaryInstructors
    ].map(({ value }) => value);
    const sbatGroupInstructorsIds = getSbatGroupInstructorsByCategory(
      sbatGroup,
      INSTRUCTOR_CATEGORIES.secondary
    ).map(({ instructor_id }) => instructor_id);

    results.push(
      intersection(filterInstructorsIds, sbatGroupInstructorsIds).length > 0
    );
  }

  if (filters[SBAT_GROUP_FILTERS.fromDate]) {
    results.push(
      new Date(sbatGroup.date_of_topic) >=
        new Date(filters[SBAT_GROUP_FILTERS.fromDate])
    );
  }

  if (filters[SBAT_GROUP_FILTERS.toDate]) {
    results.push(
      new Date(sbatGroup.date_of_topic) <=
        new Date(filters[SBAT_GROUP_FILTERS.toDate])
    );
  }
  return results.every((result) => result);
}
